import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isNonEmptyString, isArrayOf, isInteger, isDate } from "../utils/validators.js";
import { InvalidParameterError } from "../utils/errors/index.js";
export function getCycles(_x) {
  return _getCycles.apply(this, arguments);
}

function _getCycles() {
  _getCycles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var leaderboardSlug, cycleIndexes, date, request, cyclesByIndexes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            leaderboardSlug = _ref.leaderboardSlug, cycleIndexes = _ref.cycleIndexes, date = _ref.date, request = _ref.request;

            if (isArrayOf(cycleIndexes, isInteger)) {
              _context.next = 3;
              break;
            }

            throw new InvalidParameterError(1624263643, 'Parameter "cycleIndexes" must be a array of Integers');

          case 3:
            if (isNonEmptyString(leaderboardSlug)) {
              _context.next = 5;
              break;
            }

            throw new InvalidParameterError(1624263709, 'Parameter "leaderboardSlug" must be a non-empty string.');

          case 5:
            if (!(date !== undefined && !isDate(date))) {
              _context.next = 7;
              break;
            }

            throw new InvalidParameterError(1624263776, 'Parameter "date" must be a date object.');

          case 7:
            _context.next = 9;
            return request({
              method: 'GET',
              path: "/api/v1/leaderboards/".concat(leaderboardSlug, "/cycles"),
              params: _objectSpread({
                cycleIndexes: cycleIndexes
              }, date ? {
                date: date.getTime()
              } : {})
            });

          case 9:
            cyclesByIndexes = _context.sent;
            return _context.abrupt("return", Object.entries(cyclesByIndexes).reduce(function (newCyclesByIndexes, _ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  key = _ref3[0],
                  cycle = _ref3[1];

              var newCycle = cycle;

              if (cycle !== null) {
                var startDate = cycle.startDate,
                    endDate = cycle.endDate;
                newCycle = _objectSpread(_objectSpread({}, cycle), {}, {
                  startDate: new Date(startDate),
                  endDate: new Date(endDate)
                });
              } // eslint-disable-next-line no-param-reassign


              // eslint-disable-next-line no-param-reassign
              newCyclesByIndexes[key] = newCycle;
              return newCyclesByIndexes;
            }, {}));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCycles.apply(this, arguments);
}